if (!customElements.get('product-upsells')) {  
  customElements.define("product-upsells", class ProductBundler extends HTMLElement {
    constructor() {
      super();
      this.selectedProduct = null;
      this.currentVariant = null;
      this.upsell_id = document.querySelector('coco-shuffle')?.selectedProduct.id;
    }
    
    defineVariables() {
      this.products = JSON.parse(this.dataset.products.replaceAll('%27', '&apos;').replaceAll('%22', '&quot;'));
      this.atcButton = this.querySelector('[data-action="add-to-cart"]');
      this.imageWrapper = this.querySelectorAll('[data-product-images]');
      this.selectedProduct = this.products.find(({ id }) => id === this.dataset.initialProduct);
      const thisOptionSet = [...this.querySelectorAll('[data-action="option-choice"][data-option]:checked')].map(({ value }) => value);
      this.currentVariant = this.selectedProduct.variants
        .find(({ options }) => options.every((x) => thisOptionSet.find((y) => y?.toLowerCase().trim() === x?.toLowerCase().trim())));
      this.addDelegatedEventListeners();
      this.dispatchEvent(new CustomEvent('product-upsell:init', { bubbles: true }));
    }

    connectedCallback() {

      this.productUpdatedEvent = new CustomEvent('coco-shuffle:product-updated', {});
      this.showNotifications = true;

      this.defineVariables();
      
      if (document.readyState === 'complete') {
        this.defineVariables();
        this.enableOrDisableOptionSelects();
        this.enabledOrDisableAddToCartButton();
        return;
      }

      document.addEventListener('DOMContentLoaded', () => {
        this.defineVariables();
        this.enabledOrDisableAddToCartButton();
      });
    }
    
    addDelegatedEventListeners() {
      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;
        
        const {
          action,
        } = clickedElement.dataset;
            
        let optionValue = null, optionIndex = null, thisOptionSet = null;
        if (clickedElement.closest('input[type="radio"]')) {
          optionValue = clickedElement.value;
          thisOptionSet = [...this.querySelectorAll('[data-action="option-choice"][data-option]:checked')].map(({ value }) => value);
          if (this.selectedProduct) {
            optionIndex = this.selectedProduct.options_with_values
              .findIndex(({ values }) => values
                .find(x => x === optionValue));
            thisOptionSet[optionIndex] = optionValue;
          }
        }
            
        switch (action) {
          case 'add-to-cart':
            if (!this.currentVariant) {
              this.classList.add('selection-needed');
              return;
            }
            if (this._addingToCart) return;
            this._addingToCart = true;

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'upsell_click',
              event_category: 'PDP_WearItWith',
              event_label: `${this.selectedProduct?.title || ''} / ${this.currentVariant?.title || ''}`.trim().replace(/^\/\s*/, '').replace(/\s*\/$/, ''),
              product_name: this.selectedProduct?.title || '',
              product_color: this.selectedProduct?.color || '',
              variant_title: this.currentVariant?.title || '',
              variant_id: this.currentVariant?.id || '',
            });

            const data = {
              sections: [`${document.querySelector('mini-cart')?.dataset.sectionId}`],
              items: [{ 
                id: this.currentVariant?.id, 
                quantity: 1, 
                properties: { 
                  _upsell_id: this.upsell_id || false
                }
              }]
            };
            fetch('/cart/add.js', {
              body: JSON.stringify(data),
              credentials: 'same-origin',
              headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With':'xmlhttprequest'
              },
              method: 'POST'
            })
            .then((response) => {
              return response.json();
            })
            .then((json) => {
              const miniCart = document.querySelector('mini-cart');
              if (window.matchMedia('(max-width: 768px)').matches) document.querySelector('drawer-modal [data-drawer-action="close"]')?.click();
              miniCart?.updateCartHtml(json);
              setTimeout(() => {
                if (this.showNotifications && miniCart?.showNotification) {
                  miniCart.showNotification(json.items[0]);
                } else {
                  miniCart?.open();
                }
              }, window.matchMedia('(min-width: 768px)').matches ? 0 : 501);
            })
            .finally(() => {
              this._addingToCart = false;
            })
            .catch(function(err) {
              console.error(err);
            });
            
          break;
          case 'next-slide':
            this.querySelector('swiper-carousel')?.slider.slideNext();
          break;
          case 'option-choice':
            const allUpsellSelected = this.selectedProduct.options_with_values.every(({ name }) =>
              this.querySelector(`[data-option-type="${name}"]:checked`)
            );
            if (allUpsellSelected) this.classList.remove('selection-needed');
            this.currentVariant = this.selectedProduct.variants
              .find(({ options }) => options.every((x) => thisOptionSet.find((y) => y?.toLowerCase().trim() === x?.toLowerCase().trim())));
            
            this.enabledOrDisableAddToCartButton();
            this.enableOrDisableOptionSelects();
            break;
          case 'product-select':
            this.selectedProduct = this.products.find((product) => product.color === optionValue);
            {
              const tags = this.selectedProduct?.tags || [];
              const group = tags.includes('group:limited-edition') ? 'limited-edition'
                : tags.includes('group:last-chance') ? 'last-chance'
                : 'core';
              const colorDisplayEls = this.querySelectorAll('[data-display-color]');
              colorDisplayEls.forEach(el => {
                const elGroup = el.getAttribute('data-display-color-group');
                el.textContent = (elGroup === null || elGroup === group) ? optionValue : '';
              });
            }
            this.currentVariant = this.selectedProduct.variants
              .find(({ options }) => options.every((x) => thisOptionSet.find((y) => y?.toLowerCase().trim() === x?.toLowerCase().trim())));
              
            if (this.querySelector('[data-display-price]')) {
              this.querySelector('[data-display-price]').innerHTML = this.selectedProduct.price_money.endsWith('.00') ? this.selectedProduct.price_money.slice(0, -3) : this.selectedProduct.price_money;
            }
              
            this.imageWrapper.forEach((el) => {
              el.innerHTML = '';
            });
            
            if (this.selectedProduct?.featured_image) {
              this.imageWrapper.forEach((el) => {
                const hoverImage = this.selectedProduct.media.find(({ src }) => src && src !== this.selectedProduct.featured_image);
                el.href = this.selectedProduct.url;
                el.innerHTML += `
                  <div class="hidden md:flex absolute bottom-0 lg:top-0 lg:bottom-auto left-0 w-full flex-wrap gap-3 p-3 z-[1]">
                    ${this.selectedProduct.tags.map((tag) => {
                      if (!tag.includes('badge:')) return;
                      return `
                      <span class="bg-primaryLight text-primaryDark uppercase px-3 py-2 rounded-xl text-xs">
                        ${tag.replace('badge:', '')}
                      </span>
                      `;
                    }).join('')}
                  </div>
                  <img src="${this.selectedProduct.featured_image}" alt="${this.selectedProduct.featured_image_alt}" width="1200" height="1200" loading="lazy" sizes="50vw" data-featured_image="true" class="md:absolute rounded-lg transition-opacity duration-300 top-0 left-0 h-full object-cover w-full object-center ${hoverImage ? 'md:group-hover:opacity-0' : ''}">
                  ${hoverImage ? `<img src="${hoverImage.src}" alt="${hoverImage.alt}" width="1200" height="1200" class="absolute top-0 left-0 h-full object-cover object-center rounded-lg w-full transition-opacity duration-300 opacity-0 md:group-hover:opacity-100">` : ''}
                  <div aria-hidden="true" class="hidden md:block absolute top-0 left-0 w-full h-full rounded-lg bg-secondaryLight empty:hidden" data-hover-overlay=""></div>
                `;
              });
            }
            
            this.enabledOrDisableAddToCartButton();
            this.enableOrDisableOptionSelects();
          break;
          default: break;
        }        
      });
    }
    
    enabledOrDisableAddToCartButton() {
      if (!this.atcButton) return;

      const checkedOptions = this.querySelectorAll('[data-action="option-choice"]:checked');
      const totalOptionTypes = this.selectedProduct?.options_with_values?.length ?? 0;
      const allOptionsSelected = checkedOptions.length >= totalOptionTypes;

      if (!allOptionsSelected) {
        this.atcButton.removeAttribute('disabled');
        return;
      }

      if (!this.currentVariant) {
        this.atcButton.setAttribute('disabled', 'true');
        this.atcButton.innerHTML = 'Unavailable';
        return;
      }

      const price = this.currentVariant.price_money.endsWith('.00')
        ? this.currentVariant.price_money.slice(0, -3)
        : this.currentVariant.price_money;
      this.atcButton.innerHTML = `Add To Bag &bull; <span class="opacity-80">${price}</span>`;

      if (this.currentVariant.available) {
        this.atcButton.removeAttribute('disabled');
      } else {
        this.atcButton.setAttribute('disabled', 'true');
      }
    }
    
    enableOrDisableOptionSelects() {
      if (!this.selectedProduct || !Array.isArray(this.selectedProduct.variants)) return;

      const normalize = (s) => (s ?? '').toString().toLowerCase().trim();

      const selectedByIndex = [];
      const checked = [
        ...this.querySelectorAll('[data-action="option-choice"][data-option]:checked')
      ];
      checked.forEach(({ value }) => {
        const idx = this.selectedProduct.options_with_values
          ?.findIndex(({ values }) => values?.some((v) => normalize(v) === normalize(value))) ?? -1;
        if (idx > -1) selectedByIndex[idx] = value;
      });

      const availableOptionSets = this.selectedProduct.variants
        .filter((v) => v?.available)
        .map((v) => v.options || []);
      const optionSelects = [...this.querySelectorAll('[data-option]')];
      optionSelects.forEach((select) => {
        const optionValue = select.dataset.option;
        const optionIndex = this.selectedProduct.options_with_values
          ?.findIndex(({ values }) => values?.some((v) => normalize(v) === normalize(optionValue))) ?? -1;

        const candidate = [...selectedByIndex];
        if (optionIndex > -1) candidate[optionIndex] = optionValue;

        const required = candidate.filter(Boolean); 
        const isAvailable = availableOptionSets.some((set) =>
          required.every((sel) => set.some((opt) => normalize(opt) === normalize(sel)))
        );

        const group = select.closest('.group');
        const availableValues = availableOptionSets.flat().map(v => v.toLowerCase().trim());
        
        if (group) group.classList.toggle('unavailable', !isAvailable);
        if (!availableValues.includes(optionValue.toLowerCase().trim())) {
          group.classList.add('unavailable');
        }
        
      });

      const swatchInputs = [
        ...this.querySelectorAll('[data-action="product-select"][data-product-id]')
      ];

      if (checked.length === 0) {
        swatchInputs.forEach((input) => input.closest('li')?.classList.remove('oos'));
        return;
      }

      const required = selectedByIndex.filter(Boolean);

      swatchInputs.forEach((input) => {
        const li = input.closest('li');
        if (!li) return;

        const pid = String(input.dataset.productId || '');
        const product = this.products?.find((p) => String(p.id) === pid);
        if (!product || !Array.isArray(product.variants)) {
          li.classList.remove('oos');
          return;
        }

        const hasMatch = product.variants.some((v) =>
          v?.available && required.every((sel) =>
            (v.options || []).some((opt) => normalize(opt) === normalize(sel))
          )
        );

        li.classList.toggle('oos', !hasMatch);
        input.setAttribute('aria-disabled', (!hasMatch).toString());
      });
    }
  });
}